import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  ', ' background: 0;\n'], ['\n  ', ' background: 0;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  background-color: ', ';\n  border-radius: ', ';\n  align-items: center;\n  box-shadow: 0 0 0 ', ' ', ';\n  color: ', ';\n  cursor: pointer;\n  display: flex;\n  flex-basis: 100%;\n  flex-grow: 1;\n  font-size: ', 'px;\n  justify-content: center;\n  transition: box-shadow 200ms;\n'], ['\n  background-color: ', ';\n  border-radius: ', ';\n  align-items: center;\n  box-shadow: 0 0 0 ', ' ', ';\n  color: ', ';\n  cursor: pointer;\n  display: flex;\n  flex-basis: 100%;\n  flex-grow: 1;\n  font-size: ', 'px;\n  justify-content: center;\n  transition: box-shadow 200ms;\n']);

import styled from 'styled-components';
import { colors, themed } from '@atlaskit/theme';
import { getBorderRadius, getInnerStyles } from './utils';
import { BORDER_WIDTH, EXCESS_INDICATOR_FONT_SIZE } from './constants';

var getBorderWidth = function getBorderWidth(p) {
  return p.isFocus && !p.isActive ? BORDER_WIDTH[p.size] + 'px' : 0;
};

export var Outer = styled.button(_templateObject, getInnerStyles);

export var Inner = styled.span(_templateObject2, themed({ light: colors.N40, dark: colors.DN70 }), getBorderRadius, getBorderWidth, colors.B200, themed({ light: colors.N500, dark: colors.DN400 }), function (props) {
  return EXCESS_INDICATOR_FONT_SIZE[props.size];
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/avatar/dist/esm/styled/MoreIndicator.js
// module id = 441
// module chunks = 0